import { HttpClient } from '@angular/common/http';
import { IWorkflowJob, IWorkflowService } from 'interfaces-lib';
import { Observable } from 'rxjs';

export class StandardWorkflowService implements IWorkflowService {
  constructor(private http: HttpClient, public readonly workflowUrl: string, public readonly workflowStatusUrl: string) {}

  start(workflowName: string, startParams: any): Observable<IWorkflowJob> {
    console.log(`StandardWorkflowService calling start() from ${this.workflowUrl}`, workflowName, startParams);
    const url = `${this.workflowUrl}/workflow/${workflowName}`;
    const body = startParams;
    return this.http.post<IWorkflowJob>(url, body);
  }
}
